/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingfbreel2Inputs */

const en_crosspostingfbreel2 = /** @type {(inputs: Crosspostingfbreel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reel`)
};

const de_crosspostingfbreel2 = /** @type {(inputs: Crosspostingfbreel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reel`)
};

/**
* | output |
* | --- |
* | "Reel" |
*
* @param {Crosspostingfbreel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingfbreel2 = /** @type {((inputs?: Crosspostingfbreel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingfbreel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingfbreel2(inputs)
	return de_crosspostingfbreel2(inputs)
});
export { crosspostingfbreel2 as "crosspostingFbReel" }